import { Dialog } from "primereact/dialog";
import {
  CardResolutionTypeContainer,
  ModalResolveReportHeader,
} from "./components";
import { Report } from "interfaces";

export const ModalResolveReport = ({
  showModal,
  report,
  onClose,
}: {
  showModal: boolean;
  report: Report;
  onClose: Function;
}) => {
  return (
    <Dialog
      id="modal-resolve-report"
      draggable={false}
      resizable={false}
      header={<ModalResolveReportHeader />}
      visible={showModal}
      style={{
        height: 413,
        width: 600,
      }}
      onHide={() => onClose()}
      dismissableMask={true}
    >
      <CardResolutionTypeContainer report={report} onClose={onClose} />
    </Dialog>
  );
};
